import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Users, DollarSign, Crown } from "lucide-react";
import { api } from "@/lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1769650795569-e51a6e9580c3";

export default function Subscribers() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/subscribers").then((r) => setData(r.data)).catch(() => setData({ count: 0, monthly_earnings: 0, subscribers: [] }));
  }, []);

  if (!data) return <div className="p-12 text-[#A0A0A0]">Loading…</div>;

  return (
    <div className="p-6 md:p-12 max-w-3xl mx-auto">
      <button data-testid="back-btn" onClick={() => navigate("/profile")} className="text-[#A0A0A0] hover:text-white flex items-center gap-2 mb-6">
        <ArrowLeft size={20} /> Back
      </button>
      <div className="overline mb-1">Creator dashboard</div>
      <h2 className="font-heading text-3xl md:text-4xl mb-8">Your Subscribers</h2>

      <div className="grid grid-cols-2 gap-4 mb-10">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="pe-card rounded-2xl p-6" data-testid="stat-count">
          <Users className="text-[#D4AF37] mb-2" size={24} />
          <div className="font-heading text-4xl gold-text">{data.count}</div>
          <div className="text-sm text-[#A0A0A0]">Active subscribers</div>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.08 }} className="pe-card rounded-2xl p-6" data-testid="stat-earnings">
          <DollarSign className="text-[#D4AF37] mb-2" size={24} />
          <div className="font-heading text-4xl gold-text">${Number(data.monthly_earnings).toFixed(2)}</div>
          <div className="text-sm text-[#A0A0A0]">Est. monthly earnings</div>
        </motion.div>
      </div>

      {data.subscribers.length === 0 ? (
        <div className="pe-card rounded-3xl p-10 text-center">
          <Crown className="text-[#D4AF37] mx-auto mb-4" size={40} />
          <h3 className="font-heading text-2xl mb-2">No subscribers yet</h3>
          <p className="text-sm text-[#A0A0A0]">Post enticing premium content and share your profile to attract subscribers.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {data.subscribers.map((s) => (
            <div key={s.id} data-testid={`subscriber-${s.id}`} onClick={() => navigate(`/creator/${s.id}`)}
              className="pe-card rounded-2xl p-4 flex items-center gap-4 cursor-pointer">
              <img src={s.photos?.[0] || FALLBACK} alt="" className="w-12 h-12 rounded-full object-cover border border-[#D4AF37]/40" />
              <div className="flex-1">
                <div className="font-heading text-lg">{s.name}</div>
                <div className="text-xs text-[#A0A0A0]">{s.location || "Worldwide"}</div>
              </div>
              <span className="text-xs text-[#A0A0A0]">since {s.since ? new Date(s.since).toLocaleDateString() : "—"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
